"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Logo = _interopRequireDefault(require("../components/Logo/Logo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BasicTemplate = function BasicTemplateComponent(props) {
  // eslint-disable-line
  var logo = props.logo,
      contact = props.contact,
      links = props.links,
      disclaimer = props.disclaimer;
  var orderedLinks = links.sort(function (linkA, linkB) {
    return linkA.sort - linkB.sort;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-tier"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "basic-temp__wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "basic-temp"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "basic-temp__contact"
  }, contact.supportingText && /*#__PURE__*/_react["default"].createElement("span", {
    className: "basic-temp__contact__supporting-text"
  }, "".concat(contact.supportingText, " ")), /*#__PURE__*/_react["default"].createElement("a", {
    className: "basic-temp__contact__link",
    href: contact.url
  }, contact.display)), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "basic-temp__link-list"
  }, orderedLinks.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "basic-temp__link-list__item",
      key: link.id
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: link.url,
      className: "basic-temp__link",
      target: link.external ? '_blank' : '_self'
    }, link.display));
  })), /*#__PURE__*/_react["default"].createElement(_Logo["default"], logo)), disclaimer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "basic-temp__disclaimer"
  }, disclaimer))));
};

BasicTemplate.propTypes = {
  logo: _propTypes["default"].shape({
    image: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string
  }).isRequired,
  contact: _propTypes["default"].shape({
    url: _propTypes["default"].string.isRequired,
    display: _propTypes["default"].string.isRequired,
    supportingText: _propTypes["default"].string
  }).isRequired,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired,
    display: _propTypes["default"].string.isRequired,
    sort: _propTypes["default"].number.isRequired,
    external: _propTypes["default"].bool.isRequired
  })).isRequired,
  disclaimer: _propTypes["default"].string
};
BasicTemplate.defaultProps = {
  disclaimer: null
};
var _default = BasicTemplate;
exports["default"] = _default;